<template>
    <div>
        <v-data-table v-model="selectedItems" :headers="headers" :items="items" :items-per-page="itemsPerPage"
            :options.sync="options" :server-items-length="totalItems" :loading="isLoading" loader-height="2"
            item-key="id" show-select :loading-text="$t('loadingPleaseWait')" :no-data-text="$t('noUsers')"
            :no-results-text="$t('noResult')" :footer-props="{
                'items-per-page-text': $t('rowsPerPage'),
                'items-per-page-all-text': $t('all'),
            }">
            <template v-slot:item.check="{ item }">
                <v-btn fab x-small dark color="teal" @click="checkHandler({ userId: item.id, value: 1 })">
                    <v-icon>mdi-check</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <edit-snackbar v-model="isOpenEditSnack" :snack-text="editSnackText" :snack-color="editSnackColor"
            @close="resetEditSnack"></edit-snackbar>
    </div>
</template>

<script>
import { UsersService } from '../../../services';
import { MixinEditSnack, MixinTableLoadState } from '../../../mixins';
import EditSnackbar from '../../snackbars/edit-snackbar/EditSnackbar';

export default {
    name: 'NewUsersTable',
    mixins: [MixinEditSnack, MixinTableLoadState],
    components: {
        EditSnackbar
    },
    props: {
        selected: {
            required: false,
            type: Array,
            default: () => [],
        },
        filters: {
            required: false,
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            headers: [],
            items: [],
            options: {},
            itemsPerPage: 10,
            totalItems: null,
        }
    },
    computed: {
        selectedItems: {
            get() {
                return this.$store.state.selectedUsers;
            },
            set(value) {
                this.$store.commit('setSelectedUsers', value);
            }
        }
    },
    methods: {
        setHeaders() {
            UsersService.setLocale(this.$store.getters.appLanguage);
            UsersService.getNewUsersHeaders()
                .then(res => {
                    this.headers = res.data;
                })
                .catch(err => this.emitTableLoadError(err));
        },
        setItems() {
            if (!this.startTableLoading()) return;

            const params = { ...this.options, filters: this.filters };
            UsersService.setLocale(this.$store.getters.appLanguage);
            UsersService.getNewUsers(params)
                .then(res => {
                    this.items = res.data.data;
                    this.totalItems = res.data.total;
                })
                .catch(err => this.emitTableLoadError(err))
                .finally(() => {
                    this.stopTableLoading();
                });
        },
        checkHandler(data) {
            UsersService.updateParams('checked', data)
                .then(res => {
                    if (res.data.is_checked) {
                        this.items = this.items.filter(user => user.id !== res.data.id);
                        this.openSuccessEditSnack(this.$t('userChecked'));
                    }
                })
                .catch(() => {
                    this.openErrorEditSnack();
                })
        },
    },
    created() {
        this.setHeaders();
    },
    watch: {
        filters: {
            handler() {
                this.setItems();
            },
            deep: true,
        },
        options: {
            handler() {
                this.setItems();
            },
            deep: true,
        },
    }
}
</script>

<style scoped></style>
